// import React, { useState, useEffect } from 'react';
// import { getMotorcycles, updateMotorcycle } from '../../services/apiService';
// import './Motorcycles.css';

// function Motorcycles({ setSelectedMotorcycle }) {
//     const [motorcycles, setMotorcycles] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedMotorcycleId, setSelectedMotorcycleId] = useState(null);
//     const [selectedMotorcycleStatus, setSelectedMotorcycleStatus] = useState(null);
//     const [showColorPicker, setShowColorPicker] = useState(false);
//     const [selectedColor, setSelectedColor] = useState('#FFFFFF');

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const data = await getMotorcycles();
//                 setMotorcycles(data);
//             } catch (error) {
//                 console.error('Error fetching motorcycles:', error);
//             }
//         };

//         fetchData();
//     }, []);

//     const openModal = (id, currentStatus) => {
//         setSelectedMotorcycleId(id);
//         setSelectedMotorcycleStatus(currentStatus);
//         setShowModal(true);
//     };

//     const closeModal = () => {
//         setShowModal(false);
//         setSelectedMotorcycleId(null);
//         setSelectedMotorcycleStatus(null);
//     };

//     const handleUpdateStatus = async () => {
//         if (selectedMotorcycleId !== null) {
//             try {
//                 await updateMotorcycle(selectedMotorcycleId, { published: !selectedMotorcycleStatus });
//                 setMotorcycles(prevMotorcycles =>
//                     prevMotorcycles.map(motorcycle =>
//                         motorcycle.id === selectedMotorcycleId ? { ...motorcycle, published: !selectedMotorcycleStatus } : motorcycle
//                     )
//                 );
//                 closeModal();
//                 setTimeout(() => {
//                     window.location.reload();
//                 }, 1000);
//             } catch (error) {
//                 console.error('Error updating motorcycle status:', error);
//             }
//         }
//     };

//     const openColorPicker = (id, currentColor) => {
//         setSelectedMotorcycleId(id);
//         setSelectedColor(currentColor);
//         setShowColorPicker(true);
//     };

//     const closeColorPicker = () => {
//         setShowColorPicker(false);
//         setSelectedMotorcycleId(null);
//         setSelectedColor('#FFFFFF');
//     };

//     const handleColorChange = (event) => {
//         setSelectedColor(event.target.value);
//     };

//     const confirmColorChange = async () => {
//         if (selectedMotorcycleId !== null) {
//             try {
//                 // Обновляем цвет в базе данных
//                 await updateMotorcycle(selectedMotorcycleId, { Color: selectedColor });
//                 setMotorcycles(prevMotorcycles =>
//                     prevMotorcycles.map(motorcycle =>
//                         motorcycle.id === selectedMotorcycleId ? { ...motorcycle, Color: selectedColor } : motorcycle
//                     )
//                 );
//                 closeColorPicker();
//                 // Перезагрузка страницы через 1 секунду
//                 setTimeout(() => {
//                     window.location.reload();
//                 }, 1000);
//             } catch (error) {
//                 console.error('Error updating motorcycle color:', error);
//             }
//         }
//     };

//     return (
//         <div>
//             <div>
//                 {/* <h1>Available Motorcycles</h1> */}
//             </div>
//             <div className="motorcycles-list">
//                 <table>
//                     <thead>
//                         <tr>
//                             <th>No</th>
//                             <th>Name</th>
//                             <th>Farbe</th> {/* Добавляем столбец для цвета */}
//                             <th>Tagesmiete (€)</th>
//                             <th>Wochenendmiete (€)</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                     {motorcycles.map((motorcycle, index) => (
//                             <tr key={motorcycle.id}>
//                                 <td>{index + 1}</td>
//                                 <td>{motorcycle.Name}</td>
//                                 <td className='color'>
//                                     <div
//                                         className="color-circle"
//                                         style={{ backgroundColor: motorcycle.Color }}
//                                         onClick={() => openColorPicker(motorcycle.id, motorcycle.Color)}
//                                     />
//                                 </td>
//                                 <td>{motorcycle.daily_rate}</td>
//                                 <td>{motorcycle.weekend}</td>
//                                 <td>
//                                     <button onClick={() => openModal(motorcycle.id, motorcycle.published)}>
//                                         {motorcycle.published ? 'Zurückziehen' : 'Veröffentlichen'}
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Модальное окно подтверждения статуса */}
//             {showModal && (
//                 <div className="modalM">
//                     <div className="modal-contentM">
//                         <h3>Sind Sie sicher, dass Sie den Status dieses Motorrads aktualisieren möchten?</h3>
//                         <div className="modal-actionsM">
//                             <button onClick={handleUpdateStatus}>Ja</button>
//                             <button onClick={closeModal}>Nein</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Модальное окно выбора цвета */}
//             {showColorPicker && (
//                 <div className="modalM">
//                     <div className="modal-contentM">
//                         <h3>Wählen Sie eine neue Farbe:</h3>
//                         <input type="color" value={selectedColor} onChange={handleColorChange} />
//                         <div className="modal-actionsM">
//                             <button onClick={confirmColorChange}>Bestätigen</button>
//                             <button onClick={closeColorPicker}>Abbrechen</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default Motorcycles;


// Motorcycles.jsx
// import React, { useState, useEffect } from 'react';
// import { getMotorcycles, updateMotorcycle } from '../../services/apiService';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import './Motorcycles.css';

// const Motorcycles = () => {
//     const [motorcycles, setMotorcycles] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [formData, setFormData] = useState({});
//     const [isEditOpen, setIsEditOpen] = useState(false);
//     const [isConfirmOpen, setIsConfirmOpen] = useState(false);

//     useEffect(() => {
//         (async () => {
//             try {
//                 const data = await getMotorcycles();
//                 setMotorcycles(data.sort((a, b) => a.sort - b.sort));
//             } catch (e) {
//                 console.error(e);
//             }
//         })();
//     }, []);

//     const openEditor = bike => {
//         setSelected(bike);
//         setFormData({ ...bike });
//         setIsEditOpen(true);
//     };

//     const closeEditor = () => {
//         setIsEditOpen(false);
//         setSelected(null);
//         setFormData({});
//     };

//     const handleField = e => {
//         const { name, value, type, checked } = e.target;
//         setFormData(fd => ({
//             ...fd,
//             [name]: type === 'checkbox' ? checked : value
//         }));
//     };

//     const askConfirm = () => setIsConfirmOpen(true);
//     const cancelConfirm = () => setIsConfirmOpen(false);

//     const doSave = async () => {
//         try {
//             await updateMotorcycle(selected.id, formData);
//             setMotorcycles(prev =>
//                 prev.map(m => (m.id === selected.id ? { ...formData } : m))
//             );
//         } catch (e) {
//             console.error(e);
//         } finally {
//             setIsConfirmOpen(false);
//             closeEditor();
//         }
//     };

//     const handleDragEnd = async (result) => {
//         if (!result.destination) return;

//         const reordered = Array.from(motorcycles);
//         const [removed] = reordered.splice(result.source.index, 1);
//         reordered.splice(result.destination.index, 0, removed);

//         const updatedList = reordered.map((item, index) => ({
//             ...item,
//             sort: index
//         }));

//         setMotorcycles(updatedList);

//         try {
//             await Promise.all(updatedList.map(m => updateMotorcycle(m.id, { sort: m.sort })));
//         } catch (e) {
//             console.error(e);
//         }
//     };

//     return (
//         <div>
//             <DragDropContext onDragEnd={handleDragEnd}>
//                 <Droppable droppableId="motorcycles">
//                     {(provided) => (
//                         <div
//                             className="grid-container"
//                             ref={provided.innerRef}
//                             {...provided.droppableProps}
//                         >
//                             {motorcycles.map((m, index) => (
//                                 <Draggable
//                                     key={m.id.toString()}
//                                     draggableId={m.id.toString()}
//                                     index={index}
//                                 >
//                                     {(provided) => (
//                                         <div
//                                             ref={provided.innerRef}
//                                             {...provided.draggableProps}
//                                             {...provided.dragHandleProps}
//                                             className="card-item"
//                                             onClick={() => openEditor(m)}
//                                         >
//                                             {m.image && (
//                                                 <img
//                                                     src={`https://admin.motorrad-mieten-kaernten.at/assets/${m.image}`}
//                                                     alt={m.Name}
//                                                     className="card-image"
//                                                 />
//                                             )}
//                                             <h4 className="card-title">{m.Name}</h4>
//                                             <div className="rate-info">
//                                                 <span>Tag: {m.daily_rate} €</span>
//                                                 <span>Wochenende: {m.weekend} €</span>
//                                             </div>
//                                             <div
//                                                 className="color-indicator"
//                                                 style={{ backgroundColor: m.Color }}
//                                             />
//                                             <button
//                                                 className={`publish-button ${m.published ? 'on' : 'off'
//                                                     }`}
//                                             >
//                                                 {m.published ? 'Online' : 'Offline'}
//                                             </button>
//                                         </div>
//                                     )}
//                                 </Draggable>
//                             ))}
//                             {provided.placeholder}
//                         </div>
//                     )}
//                 </Droppable>
//             </DragDropContext>


//             {isEditOpen && (
//                 <div className="modal-overlay">
//                     <div className="modal-container">
//                         <h3>Edit Motorrad</h3>
//                         <div className="form-field">
//                             <label>Name</label>
//                             <input
//                                 name="Name"
//                                 value={formData.Name}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Tagestarif (€)</label>
//                             <input
//                                 name="daily_rate"
//                                 type="number"
//                                 value={formData.daily_rate}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Wochenendtarif (€)</label>
//                             <input
//                                 name="weekend"
//                                 type="number"
//                                 value={formData.weekend}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Farbe</label>
//                             <input
//                                 name="Color"
//                                 type="color"
//                                 value={formData.Color}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Marke</label>
//                             <input
//                                 name="marke"
//                                 value={formData.marke}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Kennzeichen</label>
//                             <input
//                                 name="kennzeichen"
//                                 value={formData.kennzeichen}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>FIN</label>
//                             <input
//                                 name="fin"
//                                 value={formData.fin}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Modell</label>
//                             <input
//                                 name="modell"
//                                 value={formData.modell}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field">
//                             <label>Zertifikat-Nr.</label>
//                             <input
//                                 name="certificateNumber"
//                                 value={formData.certificateNumber}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-field checkbox-field">
//                             <label>Veröffentlichen</label>
//                             <input
//                                 name="published"
//                                 type="checkbox"
//                                 checked={formData.published}
//                                 onChange={handleField}
//                             />
//                         </div>
//                         <div className="form-buttons">
//                             <button onClick={askConfirm}>Speichern</button>
//                             <button onClick={closeEditor}>Abbrechen</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {isConfirmOpen && (
//                 <div className="modal-overlay">
//                     <div className="modal-container">
//                         <h3>Sicher speichern?</h3>
//                         <div className="form-buttons">
//                             <button onClick={doSave}>Ja</button>
//                             <button onClick={cancelConfirm}>Nein</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Motorcycles;

// Motorcycles.jsx
import React, { useState, useEffect } from 'react';
import { getMotorcycles, updateMotorcycle } from '../../services/apiService';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  rectSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import './Motorcycles.css';

const SortableCard = ({ m, openEditor }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: m.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="card-item"
      onClick={() => openEditor(m)}
    >
      <div className="drag-handle" {...attributes} {...listeners}>
        ⠿
      </div>
      {m.image && (
        <img
          src={`https://admin.motorrad-mieten-kaernten.at/assets/${m.image}`}
          alt={m.Name}
          className="card-image"
        />
      )}
      <h4 className="card-title">{m.Name}</h4>
      <div className="rate-info">
        <span>Tag: {m.daily_rate} €</span>
        <span>Wochenende: {m.weekend} €</span>
      </div>
      <div
        className="color-indicator"
        style={{ backgroundColor: m.Color }}
      />
      <button
        className={`publish-button ${m.published ? 'on' : 'off'}`}
      >
        {m.published ? 'Online' : 'Offline'}
      </button>
    </div>
  );
};


const Motorcycles = () => {
  const [motorcycles, setMotorcycles] = useState([]);
  const [selected, setSelected] = useState(null);
  const [formData, setFormData] = useState({});
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const sensors = useSensors(useSensor(PointerSensor));

  useEffect(() => {
    (async () => {
      try {
        const data = await getMotorcycles();
        setMotorcycles(data.sort((a, b) => a.sort - b.sort));
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const openEditor = (bike) => {
    setSelected(bike);
    setFormData({ ...bike });
    setIsEditOpen(true);
  };

  const closeEditor = () => {
    setIsEditOpen(false);
    setSelected(null);
    setFormData({});
  };

  const handleField = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((fd) => ({
      ...fd,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const askConfirm = () => setIsConfirmOpen(true);
  const cancelConfirm = () => setIsConfirmOpen(false);

  const doSave = async () => {
    try {
      await updateMotorcycle(selected.id, formData);
      setMotorcycles((prev) =>
        prev.map((m) => (m.id === selected.id ? { ...formData } : m))
      );
    } catch (e) {
      console.error(e);
    } finally {
      setIsConfirmOpen(false);
      closeEditor();
    }
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = motorcycles.findIndex((m) => m.id === active.id);
    const newIndex = motorcycles.findIndex((m) => m.id === over.id);

    const reordered = arrayMove(motorcycles, oldIndex, newIndex).map(
      (item, index) => ({ ...item, sort: index })
    );

    setMotorcycles(reordered);

    try {
      await Promise.all(
        reordered.map((m) => updateMotorcycle(m.id, { sort: m.sort }))
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          items={motorcycles.map((m) => m.id)}
          strategy={rectSortingStrategy}
        >
          <div className="grid-container">
            {motorcycles.map((m) => (
              <SortableCard key={m.id} m={m} openEditor={openEditor} />
            ))}
          </div>
        </SortableContext>
      </DndContext>

      {isEditOpen && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h3>Edit Motorrad</h3>
            <div className="form-field">
              <label>Name</label>
              <input name="Name" value={formData.Name} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Tagestarif (€)</label>
              <input name="daily_rate" type="number" value={formData.daily_rate} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Wochenendtarif (€)</label>
              <input name="weekend" type="number" value={formData.weekend} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Farbe</label>
              <input name="Color" type="color" value={formData.Color} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Marke</label>
              <input name="marke" value={formData.marke} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Kennzeichen</label>
              <input name="kennzeichen" value={formData.kennzeichen} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>FIN</label>
              <input name="fin" value={formData.fin} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Modell</label>
              <input name="modell" value={formData.modell} onChange={handleField} />
            </div>
            <div className="form-field">
              <label>Zertifikat-Nr.</label>
              <input name="certificateNumber" value={formData.certificateNumber} onChange={handleField} />
            </div>
            <div className="form-field checkbox-field">
              <label>Veröffentlichen</label>
              <input name="published" type="checkbox" checked={formData.published} onChange={handleField} />
            </div>
            <div className="form-buttons">
              <button onClick={askConfirm}>Speichern</button>
              <button onClick={closeEditor}>Abbrechen</button>
            </div>
          </div>
        </div>
      )}

      {isConfirmOpen && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h3>Sicher speichern?</h3>
            <div className="form-buttons">
              <button onClick={doSave}>Ja</button>
              <button onClick={cancelConfirm}>Nein</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Motorcycles;
